// components/GlobalInterstitialTrigger.tsx
'use client';

import { useEffect, useRef } from 'react';
import { useInterstitialAds } from './useInterstitialAds'; // your web hook

type Props = {
  adUnitPath?: string;
  enabled?: boolean;
};

export const GlobalInterstitialTrigger = ({ adUnitPath, enabled = true }: Props) => {
  const { showAd, loaded } = useInterstitialAds({ adUnitId: adUnitPath });
  const firedRef = useRef(false);

  useEffect(() => {
    if (!enabled) return;

    const once = () => {
      // Ensure we only call once per page lifecycle
      console.log("Is ad loaded => ", loaded);
      if (firedRef.current && !loaded) return;
      firedRef.current = true;

      // Fire the interstitial show; GPT will respect frequency caps & fill
      showAd();

      // After the first interaction, we can remove all listeners
      detach();
    };

    // Valid user-gesture events browsers consider “active”
    const events: Array<keyof DocumentEventMap> = ['click', 'pointerdown', 'touchstart', 'keydown'];

    const attach = () =>
      events.forEach((evt) =>
        document.addEventListener(evt, once, { passive: true, capture: true })
      );
    const detach = () =>
      events.forEach((evt) => document.removeEventListener(evt, once, { capture: true }));

    attach();
    return detach;
  }, [enabled, showAd, loaded]);

  return null;
};
